import { AUTH_CONFIG } from '@auth-oauth2/config'
import { AuthOauth2 } from '@auth-oauth2/core/auth'
import { getClientId } from '@auth-oauth2/core/clientId'
import { getIssuerUrl } from '@auth-oauth2/core/issuerUrl'
import sessionStorage from '@core/helpers/sessionStorage'

export default function authOauthPlugin(ctx, inject) {
  const options = { ...AUTH_CONFIG }

  // This is used to load the plugin only in the specified countries,
  // passed as a FF, to enable progressive rollout.
  options.countriesIsEnabled = ctx.$config.FF_OAUTH2_FLOWS_ENABLED_BY_COUNTRY

  // We can disable this condition once we rollout to 100% countries and environments.
  const shouldLoad =
    Boolean(options.countriesIsEnabled) &&
    Boolean(ctx.store.getters['config/country']) &&
    options.countriesIsEnabled.includes(ctx.store.getters['config/country'])

  if (!shouldLoad) {
    return
  }

  // get auth issuer url dynamically depending on the host
  options.domainBaseUrl = getIssuerUrl(ctx.store.getters['config/apiBaseUrl'])

  // get client id dynamically depending on the region
  options.clientId = getClientId(
    ctx.store.getters['config/apiBaseUrl'],
    ctx.store.getters['config/marketplace'],
  )

  inject('auth', new AuthOauth2(options, ctx, sessionStorage))
}
